import React, { Component } from "react";
import "./App.scss";

//import 'bootstrap/dist/css/bootstrap.min.css';
import ToastMessage from "controllers/alert/Toast";
import ProductState from "controllers/modals/ProductState";
import GoogleLocation from "controllers/modals/GoogleLocation";
import ProductReservationModal from "controllers/modals/ProductReservation";
import CancelMyProductReservationModal from "controllers/modals/CancelMyProductReservation";

import Root from "./controllers/Root";
import Menu from "./controllers/Menu";
import Loader from "./controllers/Loader";
import { connect } from "react-redux";

import CookieHelper from "helpers/cookie";
import DashboardAPI from "api/Dashboard";
import { SET_USER } from "actions/types";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

class App extends Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
    this.toggleMenu = this.toggleMenu.bind(this);

    this.state = { error: null, isLoaded: null, user: null };
  }

  /*
	componentDidMount() {
		console.log("app did mount");	
	}

	componentWillUnmount() {
		console.log( "component unmount" );
	}
	*/
  componentDidMount() {
    window.process = { ...window.process };
  }

  async getDashboardData() {
    const { dispatch, isLoggedIn, user } = this.props;
    if (isLoggedIn && user && user.id == 0) {
      try {
        var response = await DashboardAPI.getDashboard();
        dispatch({ type: SET_USER, payload: { user: response.data.data } });
      } catch (err) {
        //console.log(err);
      }
    }
  }

  toggleMenu() {
    this.menuToggleEvent();
  }

  render() {
    let rawMMEVObj = CookieHelper.getCookie("mmev_obj");
    const { isLoggedIn, user } = this.props;

    let appClassName = "App ";
    if (!isLoggedIn) {
      appClassName += "fullPage";
    }
    let prefixUrl = "/";
    var mmev = window.mmev;

    if (mmev && mmev.mmev_account_slug && mmev.mmev_account_slug != "") {
      prefixUrl = mmev.mmev_account_slug;
    }

    if (isLoggedIn) {
      this.getDashboardData();
    }
    //		console.log( t );
    //		console.log("route", useRoutes());
    //const routing = useRoutes(routes());
    let isProvider = user && user.isProvider();

    return (
      <div className={appClassName}>
        <Loader />
        <ToastMessage />
        {isLoggedIn ? (
          <>
            <div className="flex ct-container loggedInDashboard">
              <ProductState />
              <ProductReservationModal />
              <CancelMyProductReservationModal />
              <GoogleLocation />
              <Router basename={prefixUrl}>
                <Menu />
                <main className="flex-1 py-10">
                  <div className="sm:ps-6 lg:ps-8">
                    <Routes>
                      <Route
                        exact
                        path="/"
                        element={<Root view="dashboard" />}
                      ></Route>
                      <Route path="profile" element={<Root view="profile" />} />
                      <Route
                        path="company"
                        element={<Root view="companyoverview" />}
                      />
                      <Route
                        path="company/add"
                        element={<Root view="company-add" />}
                      />
                      <Route
                        path="company/edit/:id"
                        element={<Root view="company-add" />}
                      />
                      <Route
                        path="company/:companyid/user"
                        element={<Root view="company-user-overview" />}
                      />
                      <Route
                        path="company/:companyid/user/add"
                        element={<Root view="company-user-add" />}
                      />
                      <Route
                        path="company/:companyid/user/edit/:id"
                        element={<Root view="company-user-add" />}
                      />
                      <Route
                        path="products"
                        element={<Root view="product-overview" />}
                      />
                      <Route
                        path="products/add"
                        element={<Root view="product-add" />}
                      />
                      <Route
                        path="products/edit/:id"
                        element={<Root view="product-add" />}
                      />
                      <Route
                        path="products/reservation"
                        element={<Root view="product-reservation-overview" />}
                      />
                      <Route
                        path="products/my-reservations"
                        element={<Root view="my-reservations" />}
                      />

                      <Route path="logout" element={<Root view="logout" />} />
                      <Route exact path="*" element={<Navigate to="/" />} />
                    </Routes>
                  </div>
                </main>
              </Router>
            </div>
            <div className="container loggedInDashboard">
              <div className="row">
                <Router basename={prefixUrl}>
                  {/* {user && user.id > 0 && user.state == 1 && (
                  <div className="col-12">
                    <Alert variant="warning">
                      <Alert.Heading>Hoi, {user.full_name}</Alert.Heading>
                      <p>
                        Je profiel is nog niet compleet. Zorg dat alle
                        verplichte velden zijn ingevuld zodat u uw materiaal
                        meteen kunt reserveren.
                        <br />
                        Klik op{" "}
                        <Link to="/profile">
                          <span className="profiel">Mijn profiel</span>
                        </Link>{" "}
                        om direct je profiel te bewerken.
                      </p>
                      <hr />
                      <p className="mb-0">
                        Als u er niet uitkomt neemt u dan contact op met
                        info@circufy.nl of 071-xxxxx
                      </p>
                    </Alert>
                  </div>
                )} */}
                </Router>
              </div>
            </div>
          </>
        ) : (
          <Router basename={prefixUrl}>
            <Routes>
              <Route exact path="login" element={<Root view="login" />} />
              <Route
                exact
                path="resetpassword"
                element={<Root view="reset-password" />}
              />
              <Route exact path="signin" element={<Root view="signin" />} />
              <Route
                path="verify/:verifyKey"
                element={<Root view="account-verify" />}
              />
              <Route
                path="resetpassword/:resetKey"
                element={<Root view="reset-password-verify" />}
              />
              <Route path="logout" element={<Root view="logout" />} />
              <Route
                exact
                path="*"
                element={<Navigate replace to="/login" />}
              />
            </Routes>
          </Router>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { isLoggedIn, user } = state.auth;
  return {
    user,
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(App);
